/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import AliceCarousel from "react-alice-carousel";
import advertiseImage from "../../assets/nextplaces.png";
import "react-alice-carousel/lib/alice-carousel.css";
import { useNavigate } from "react-router-dom";
import "./style.scss";
import { getNextPlaces } from "../../services/nextPlaces.services";
import { toast } from "react-toastify";
import candleImg from "../../assets/candle-line.svg";
// import "../../pages/Home/home.scss";

const handleDragStart = (e) => e.preventDefault();

const responsive = {
  0: { items: 1 },
  568: { items: 2 },
  1024: {
    items: 4,
  },
};

function NextPlaces() {
  const [nextPlacesData, setNextPlacesData] = useState([]);

  const navigate = useNavigate();

  const fetchNextPlaces = async () => {
    try {
      let response = await getNextPlaces();
      if (response && response?.status === 200) {
        setNextPlacesData(
          response.data?.map((item) => (
            <div className="place_style">
              <div
                className="place_image"
                onClick={() =>
                  navigate(`category-detail/?tzadikimId=${item.id}`)
                }
                // style={{ height: "300px" }}
              >
                <img
                  src={advertiseImage}
                  onDragStart={handleDragStart}
                  alt=""
                />
              </div>
              <h3 className="title">
                {item.title} - {item.nfDay} {item.nfMonth} {item.nfYear}
              </h3>
            </div>
          ))
        );
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Oops.. something went wrong, try again !!!",
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        }
      );
    }
  };

  useEffect(() => {
    fetchNextPlaces();
  }, []);

  return (
    <div
      className="nt-topplace_section"
      style={{
        background:
          "linear-gradient(180deg, #FFFCF8 17.84%, #FFF3E4 48.51%, #FFFCF8 86.73%)",
      }}
    >
      <div style={{ marginInline: "auto" }}>
        <div className="topplace_slider">
          {/* <div className="topplace_header">
            <Link to="/next-places" className="topplace_heading">
              <h4>
                {" "}
                <img className="candle-img" src={candleImg} alt="candle" />
                יארצייטן
              </h4>
            </Link>
          </div> */}
          <div
            className="nt-topplace_button"
            onClick={() => navigate("/next-places")}
          >
            <img className="nt-topplace_image" src={candleImg} alt="candle" />
            <span className="nt-topplace_text">יארצייטן</span>
          </div>
          <div className="image_carousel">
            <AliceCarousel
              mouseTracking
              responsive={responsive}
              items={nextPlacesData}
              autoPlay
              infinitetopplace_heading
              autoPlayStrategy="all"
              autoPlayInterval={5000}
              disableButtonsControls
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NextPlaces;
